// Admin — critical alert SMS numbers (Yabbr) for outage/queue alerts.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageSquareWarning } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AlertSmsCard = () => {
  const [numbers, setNumbers] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const sendTest = async () => {
    setTesting(true);
    try {
      const r = await axios.post(`${API}/admin/alert-sms-test`);
      if (r.data.sent > 0) toast.success(`Test SMS sent to ${r.data.sent} number${r.data.sent === 1 ? '' : 's'}`);
      else toast.error(`Test SMS failed${(r.data.failed || []).length ? ` for ${r.data.failed.join(', ')}` : ''} — check Yabbr credentials`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Test failed');
    }
    setTesting(false);
  };

  useEffect(() => {
    axios.get(`${API}/admin/alert-sms-numbers`)
      .then((r) => { setNumbers((r.data.numbers || []).join(', ')); setEnabled(r.data.enabled !== false); })
      .catch(() => setNumbers(''));
  }, []);

  const save = async (nextEnabled = enabled) => {
    setSaving(true);
    try {
      const list = String(numbers || '').split(/[,;\n]/).map((n) => n.trim()).filter(Boolean);
      const r = await axios.put(`${API}/admin/alert-sms-numbers`, { numbers: list, enabled: nextEnabled });
      setNumbers((r.data.numbers || []).join(', '));
      setEnabled(r.data.enabled);
      toast.success('Alert SMS settings saved');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Save failed');
    }
    setSaving(false);
  };

  return (
    <div className="bg-white/[0.03] border border-white/10 rounded-xl p-4" data-testid="alert-sms-card">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-white font-bold text-sm flex items-center gap-2">
          <MessageSquareWarning className="w-4 h-4 text-amber-300" /> Critical alert SMS
        </h3>
        <button onClick={() => save(!enabled)} disabled={saving}
          className={`text-[10px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full ${enabled ? 'bg-teal-500/20 text-teal-300' : 'bg-white/10 text-white/40'}`}
          data-testid="alert-sms-enabled-toggle">
          {enabled ? 'On' : 'Off'}
        </button>
      </div>
      <p className="text-white/40 text-[11px] mb-2">
        GymSales outage/recovery and grading-queue backlog alerts are texted to these numbers via Yabbr (comma-separated).
      </p>
      <div className="flex gap-2">
        <input value={numbers ?? ''} onChange={(e) => setNumbers(e.target.value)}
          className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-white/30"
          placeholder="0421664433, 0408755522" data-testid="alert-sms-numbers-input" />
        <button onClick={() => save()} disabled={saving || numbers === null}
          className="bg-teal-500 text-slate-950 font-bold text-sm px-4 rounded-lg hover:bg-teal-400 disabled:opacity-50"
          data-testid="alert-sms-save-btn">
          {saving ? 'Saving…' : 'Save'}
        </button>
        <button onClick={sendTest} disabled={testing}
          className="border border-white/20 text-white/80 font-bold text-sm px-4 rounded-lg hover:bg-white/10 disabled:opacity-50"
          data-testid="alert-sms-test-btn">
          {testing ? 'Sending…' : 'Send test SMS'}
        </button>
      </div>
    </div>
  );
};
